import type { BrokerNotification, BrokerNotificationKind } from './broker-notifications-api.js';

/**
 * KAM VEDE KLIK NA UPOZORNENI (krok NOTIF1 bod 3: „klik vede na misto").
 *
 * Cesta se ODVOZUJE tady, v UI — server zadnou adresu obrazovky
 * neposila ani neuklada. Duvod: adresy obrazovek jsou vec web-adminu
 * (prejmenovani routy by jinak znamenalo migraci dat) a stejne upozorneni
 * muze v jine aplikaci (mobil) vest jinam.
 *
 * PRAVIDLO: kdyz upozorneni patri k ZAKAZCE, vede na jeji detail — tam
 * makler vec skutecne vyridi. Bez zakazky vede na prehled, kam ta vec
 * patri (poptavky, smlouvy, fakturace, proverení).
 */
export interface NotificationTarget {
  readonly to: string;
  readonly params?: Readonly<Record<string, string>> | undefined;
}

const LIST_TARGETS: Readonly<Record<BrokerNotificationKind, string>> = {
  'nova-poptavka': '/poptavky',
  'podpis-dokoncen': '/smlouvy',
  'formular-vyplnen': '/klienti',
  'provereni-hotovo': '/audit',
  'provereni-ceka-doklady': '/k-doplneni',
  'faktura-zaplacena': '/fakturace',
  'lhuta-blizi': '/kalendar',
  // Krok PROP7 bod 3: makler ma aktualizovat smlouvu a inzerat te nemovitosti.
  'adresa-zmenena': '/zakazky',
  // Krok NAP9 bod A22: nova revize uz doruceneho reportu - makler si ji
  // precte u provereni, odkud report odesel.
  'report-nova-revize': '/audit',
  // Krok NAP15 bod A8: cenu makler meni u zakazky (a bez zakazky to
  // upozorneni nevznika - planovac bezi prave nad zakazkami).
  'cena-v-okoli': '/zakazky',
  // Krok DOM1: vlastni domena se nastavuje v Nastaveni -> Web kancelare,
  // tam makler i uvidi, co s DNS nesedi.
  'domena-vypnuta': '/nastaveni',
  // Krok SCHV1 bod 3: pripominky majitele vyridi makler u zakazky (a bez
  // zakazky tohle upozorneni nevznika - vzdy visi na verejne strance zakazky).
  'majitel-pripominky': '/zakazky',
};

export function notificationTarget(
  notification: Pick<BrokerNotification, 'kind' | 'caseId'>,
): NotificationTarget {
  /*
   * Vyjimka: NOVA POPTAVKA vede vzdy na tabuli poptavek, i kdyz uz
   * zakazku ma. Poptavka je prvni kontakt — makler na ni odpovida ve
   * svem sloupci, ne v detailu zakazky.
   */
  if (notification.kind !== 'nova-poptavka' && notification.caseId !== null) {
    return { to: '/zakazky/$id', params: { id: notification.caseId } };
  }
  return { to: LIST_TARGETS[notification.kind] };
}
